.event-timeline-component-type.full-screen .event-timeline-panel {
  height: calc(100vh - 69px - 2rem - 2rem - 56px - 2rem);
}
.event-timeline-component-type.full-screen .event-timeline-panel .event-timeline-event-list .split {
  min-height: 200px;
}

.event-timeline-panel {
  user-select: none;
}
.event-timeline-panel .drop-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 15rem;
  position: relative;
}
.event-timeline-panel .drop-wrapper:focus {
  outline: none;
}
.event-timeline-panel .drop-wrapper > div:not(:first-child):not(.drop-zone) + div {
  margin-top: 1rem;
}
.event-timeline-panel .drop-wrapper .drop-zone {
  position: absolute;
  padding: 1rem;
  border: 2px dashed gray;
  display: flex;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  z-index: 100;
}
.event-timeline-panel .event-timeline-view > div > svg {
  cursor: crosshair;
}
.event-timeline-panel .event-timeline-brush svg {
  overflow: visible;
}

.event-timeline-info-header {
  display: flex;
  justify-content: space-between;
  color: rgb(50%, 50%, 50%);
  font-size: 0.75rem;
  margin-bottom: 0.25rem;
}
.event-timeline-info-header.over-chart div:first-child {
  margin-left: 70px;
}
.event-timeline-info-header.over-list div:first-child {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.event-timeline-info-header .event-timeline-legend li {
  float: left;
  margin-right: 0.5rem;
  font-size: 0.85rem;
}
.event-timeline-info-header .event-timeline-legend li svg {
  margin-right: 0.25rem;
}
.event-timeline-info-header .event-timeline-info .limited-event-info {
  position: relative;
  display: flex;
  align-items: center;
}
.event-timeline-info-header .event-timeline-info .limited-event-info .info-text {
  margin-right: 0.5rem;
}
.event-timeline-info-header .event-timeline-info .limited-event-info-trigger.user .event-info-icon, .event-timeline-info-header .event-timeline-info .limited-event-info-trigger.list .event-info-icon {
  color: #3366ff;
}
.event-timeline-info-header .event-timeline-info .limited-event-info-trigger.user:hover + div, .event-timeline-info-header .event-timeline-info .limited-event-info-trigger.list:hover + div {
  display: block;
  position: absolute;
  top: -5rem;
}
.event-timeline-info-header .event-timeline-info .limited-event-info-tooltip {
  display: none;
  background: white;
  width: 30rem;
  border: 1px solid #cccccc;
  border-radius: 0.3rem;
  padding: 1rem;
  top: 9.5rem;
  right: 0;
  line-height: 1.2rem;
}
.event-timeline-info-header .event-timeline-info .limited-event-info-tooltip p:not(:last-child) {
  padding-bottom: 0.5rem;
}

.event-timeline-tooltip {
  padding: 1rem;
  font-size: 1rem;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.85);
  color: rgb(10%, 10%, 10%);
  min-width: 20rem;
}
.event-timeline-tooltip > * + * {
  margin-top: 0.5rem;
}
.event-timeline-tooltip__fixed-width-label {
  width: 50px;
  display: inline-block;
}
.event-timeline-tooltip__severity {
  text-transform: capitalize;
  color: #000;
  font-weight: 500;
}
.event-timeline-tooltip__severity--critical {
  color: #f03040;
}
.event-timeline-tooltip__severity--warning {
  color: #ffd800;
}
.event-timeline-tooltip__details {
  margin: 0.5rem 1.25rem;
  line-height: 1.25;
}
.event-timeline-tooltip__details div span {
  min-width: 6rem;
  display: inline-block;
  font-size: 14px;
}
.event-timeline-tooltip__details div span:first-child {
  color: #808080;
}
.event-timeline-tooltip__details div span:last-child {
  color: #000000;
}
.event-timeline-tooltip__severity-groups {
  color: #808080;
  margin-top: 1rem;
}
.event-timeline-tooltip__severity-groups > * + * {
  margin-top: 0.5rem;
}
.event-timeline-tooltip__timestamp {
  color: #808080;
}
.event-timeline-tooltip__duration {
  display: flex;
  align-items: center;
}
.event-timeline-tooltip__duration .avt-react-components--icon {
  display: flex;
  align-items: center;
  width: 9px;
  height: 9px;
  margin: 0 0.3rem;
}
.event-timeline-tooltip__name {
  font-weight: 500;
}
.event-timeline-tooltip__indicators {
  display: flex;
  justify-content: flex-end;
}
.event-timeline-tooltip__indicators--comments, .event-timeline-tooltip__indicators--attachments {
  position: relative;
  margin-right: 1rem;
}
.event-timeline-tooltip__indicators--comments .pill-component, .event-timeline-tooltip__indicators--attachments .pill-component {
  position: absolute;
  top: -0.4rem;
  right: -0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.4rem;
  height: 1.1rem;
  border-radius: 50%;
}
.event-timeline-tooltip__indicators--comments .pill-component .text, .event-timeline-tooltip__indicators--attachments .pill-component .text {
  margin-left: 0;
}

.tooltip-box {
  border-radius: 0.25rem;
  font-size: 0.86rem;
  padding: 0.35rem 0.5rem 0.4rem 0.5rem;
  word-break: break-word;
  white-space: normal;
  text-align: center;
  overflow-wrap: break-word;
}
.tooltip-box.theme-light {
  background-color: #333333;
  color: #ffffff;
}
.tooltip-box.theme-dark {
  background-color: rgb(95%, 95%, 95%);
  color: black;
}

body.select-none {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.event-timeline-chart-area {
  position: relative;
  margin-bottom: 1rem;
}
.event-timeline-chart-area .iot-event-option {
  display: flex;
  align-items: center;
}
.event-timeline-chart-area .iot-event-option div:not(:last-child) {
  margin-right: 0.5rem;
}

.timeline-chart-event {
  cursor: pointer;
}

.event-timeline-list-container {
  overflow-y: hidden;
  height: 100%;
}
.event-timeline-list-container.limited {
  overflow-x: hidden;
}
.event-timeline-list-container:not(.limited) {
  position: relative;
}

.event-timeline-event-list {
  border: 1px solid rgba(89, 89, 89, 0.3);
  height: 100%;
}
.event-timeline-event-list.limit-list {
  border: none;
}
.event-timeline-event-list--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.event-timeline-event-list .list-view {
  width: 100% !important;
  overflow-y: scroll !important;
}

.event-timeline-event-list-headers {
  display: flex;
  font-weight: 500;
  background: rgb(95%, 95%, 95%);
  color: rgb(10%, 10%, 10%);
  border-bottom: 1px solid rgba(89, 89, 89, 0.3);
}
.event-timeline-event-list-headers .list-header {
  padding: 0.5rem 0.7rem 0.5rem 0.5rem;
  border-right: 0.2rem solid #ffffff;
  box-sizing: border-box;
}
.event-timeline-event-list-headers .list-header:last-child, .event-timeline-event-list-headers .list-header:nth-last-child(2) {
  border-right: none;
}
.event-timeline-event-list-headers .list-header.date-column {
  flex: 4 0 215px;
  min-width: 215px;
}
.event-timeline-event-list-headers .list-header.date-column.avt-react-components--button {
  padding: 0.5rem 0.7rem 0 0.5rem;
  flex: 4 0 215px;
  min-width: 215px;
  border-top: none;
  border-left: none;
  align-items: flex-start;
  line-height: 16px;
}
.event-timeline-event-list-headers .list-header.date-column.avt-react-components--button .avt-react-components--icon {
  display: flex;
  flex-direction: column;
  top: 2px;
  left: 4px;
  position: relative;
}
.event-timeline-event-list-headers .list-header.active-column, .event-timeline-event-list-headers .list-header.activity-column, .event-timeline-event-list-headers .list-header.state-column {
  flex: 1 0 85px;
  min-width: 85px;
}
.event-timeline-event-list-headers .list-header.type-column, .event-timeline-event-list-headers .list-header.pointId-column, .event-timeline-event-list-headers .list-header.group-column, .event-timeline-event-list-headers .list-header.sender-column, .event-timeline-event-list-headers .list-header.assignedTo-column {
  flex: 4 1 165px;
  min-width: 150px;
}
.event-timeline-event-list-headers .list-header.message-column {
  flex: 6 2 250px;
  min-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.event-timeline-event-list-headers .list-header.label-column {
  flex: 2 1 120px;
  min-width: 100px;
}
.event-timeline-event-list-headers .list-header.actions-column {
  flex: 1 0 85px;
  min-width: 85px;
  padding: 0.5rem;
}
.event-timeline-event-list-headers .list-header.scroll-spacer {
  flex: 0 0 6px;
  padding: 0;
}

.event-timeline-list-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  background-color: #ffffff;
  border-bottom: 1px solid rgba(89, 89, 89, 0.3);
  border-right: 1px solid rgba(89, 89, 89, 0.3);
  width: calc(100% - 2px);
}
.event-timeline-list-item.overdue {
  background-color: #ec575b;
}
.event-timeline-list-item.todo {
  background-color: #ede27f;
}
.event-timeline-list-item__date {
  display: flex;
  flex: 4 0 215px;
  min-width: 215px;
  align-items: center;
  line-height: 1.3rem;
  padding: 0 0.5rem;
}
.event-timeline-list-item__type {
  flex: 4 1 165px;
  min-width: 150px;
  line-height: 1.3rem;
  text-transform: capitalize;
  padding: 0 0.5rem;
}
.event-timeline-list-item__message {
  flex: 6 2 250px;
  min-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3rem;
  padding: 0 0.5rem;
}
.event-timeline-list-item__label {
  flex: 2 1 120px;
  min-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3rem;
  padding: 0 0.5rem;
}
.event-timeline-list-item__label .event-label {
  border-radius: 4px;
  background: rgb(90%, 90%, 90%);
  padding-inline: 8px;
  display: inline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.event-timeline-list-item__active, .event-timeline-list-item__activity, .event-timeline-list-item__state, .event-timeline-list-item__actions {
  flex: 1 0 85px;
  min-width: 85px;
  padding: 0 0.5rem;
}
.event-timeline-list-item__sender, .event-timeline-list-item__assignedTo, .event-timeline-list-item__group, .event-timeline-list-item__pointId {
  flex: 4 1 165px;
  min-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3rem;
  padding: 0 0.5rem;
}
.event-timeline-list-item--limited-list {
  flex-direction: column;
  justify-content: center;
  padding: 0.5rem 1rem;
  border: 0;
  border-radius: 0.3rem;
  height: 60px;
  background-color: rgb(95%, 95%, 95%);
}
.event-timeline-list-item--limited-list > div {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 0 0.5rem;
}
.event-timeline-list-item--limited-list > div:not(:last-child) {
  padding-bottom: 0.3rem;
}
.event-timeline-list-item--limited-list .event-timeline-list-item_type {
  flex: 1;
}
.event-timeline-list-item--limited-list .event-timeline-list-item__date,
.event-timeline-list-item--limited-list .event-timeline-list-item__actions {
  flex: 1;
  justify-content: flex-end;
}
.event-timeline-list-item--limited-list .event-timeline-list-item__actions .event-timeline-user-event-status {
  justify-content: flex-end;
}
@media only screen and (max-width: 1330px) {
  .event-timeline-list-item--limited-list-narrow {
    justify-content: flex-start;
    height: 77px;
  }
  .event-timeline-list-item--limited-list-narrow > div {
    align-items: flex-start;
  }
  .event-timeline-list-item--limited-list-narrow > div:not(:last-child) {
    flex-direction: column;
    padding-bottom: 0;
  }
  .event-timeline-list-item--limited-list-narrow > div > div {
    padding-bottom: 0.5rem;
    padding-left: 0;
  }
  .event-timeline-list-item--limited-list-narrow .event-timeline-list-item__date {
    padding-bottom: 0.4rem;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1330px) {
  .event-timeline-list-item--limited-list-narrow {
    height: 82px;
  }
}
.event-timeline-list-item--loading {
  display: flex;
  align-items: center;
  justify-content: center;
}
.event-timeline-list-item--clickable {
  cursor: pointer;
}
.event-timeline-list-item--critical {
  background-color: #f8d9d8;
}
.event-timeline-list-item--warning {
  background-color: #fef7de;
}
.event-timeline-list-item--hovering {
  box-shadow: inset 0px 0px 0.5px 1.5px #3366ff;
  z-index: 1;
}
.event-timeline-list-item--limited-list.event-timeline-list-item--hovering {
  box-shadow: none;
  background-color: rgb(90%, 90%, 90%);
}

.limited-list-wrapper {
  display: block;
}
.limited-list-wrapper .event-timeline-list-item__message {
  display: flex;
  align-items: center;
  max-width: 75%;
}
.limited-list-wrapper .event-timeline-list-item__message > div:first-child {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.event-timeline-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
  align-items: flex-end;
  justify-content: flex-end;
}
@media only screen and (min-width: 1770px) {
  .event-timeline-filters {
    margin-left: 0;
  }
}
.event-timeline-filters .popout-select--trigger.round svg {
  color: rgb(70%, 70%, 70%);
}
.event-timeline-filters .avt-react-components--input {
  line-height: 1rem;
  height: calc(1rem + 1px);
  box-sizing: content-box;
  padding: 0.5rem;
  width: 12rem;
}
.event-timeline-filters .avt-react-components--input:hover:not(:focus) {
  border-color: rgb(70%, 70%, 70%);
}
.event-timeline-filters .avt-react-components--input::placeholder {
  color: #666666;
  font-weight: 400;
}
.event-timeline-filters .select-period-component .header {
  box-sizing: border-box;
  width: 100%;
}

.event-timeline-panel-header {
  margin-bottom: 1rem;
}
.event-timeline-panel-header .event-timeline-panel-toolbar {
  display: flex;
  gap: 0.5rem;
  width: 100%;
  align-items: flex-start;
  margin-bottom: 0.5rem;
  justify-content: space-between;
}
.event-timeline-panel-header .event-timeline-panel-toolbar .event-timeline-panel-btn-wrapper {
  display: flex;
  gap: 0.5rem;
}
.event-timeline-panel-header .event-timeline-panel-toolbar .event-timeline-filters .event-timeline-search {
  display: flex;
  align-items: flex-end;
  width: 23%;
}
.event-timeline-panel-header .event-timeline-panel-toolbar .event-timeline-filters .event-timeline-search .avt-react-components--input {
  width: 100%;
  height: 1rem;
}
@media only screen and (max-width: 1305px) {
  .event-timeline-panel-header.wide .event-timeline-panel-toolbar .event-timeline-filters .avt-react-components--input {
    width: 100%;
  }
}
@media only screen and (max-width: 840px) {
  .event-timeline-panel-header.widest .event-timeline-panel-toolbar button:nth-child(2) {
    padding: 0 0.4rem;
  }
  .event-timeline-panel-header.widest .event-timeline-panel-toolbar button:nth-child(2) .avt-react-components--icon {
    margin-right: 0;
  }
  .event-timeline-panel-header.widest .event-timeline-panel-toolbar button:nth-child(2) .button-text {
    display: none;
  }
}

.event-timeline-user-event-status {
  display: flex;
  justify-content: space-evenly;
}

.severity-indicator {
  margin-right: 8px;
}
.severity-indicator--panel {
  margin-right: 0;
}

.related-events {
  height: 124.5px;
}
.related-events.empty {
  height: 0px;
}
.related-events__list .avt-react-components--button,
.related-events__list .event-count {
  margin-top: 1rem;
  font-size: 0.75rem;
}
.related-events__list .event-count {
  display: flex;
  justify-content: center;
  color: #666666;
}
.related-events__display-item {
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
}
.related-events__display-item.clickable {
  cursor: pointer;
}
.related-events__display-item > *:first-child {
  flex: 0 0 auto;
  margin: 0 10px;
}
.related-events p {
  min-height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.related-events__see-all {
  display: block;
  margin: 0 auto;
}
.related-events__buttons {
  display: flex;
  margin-top: 1rem;
}
.related-events__buttons button {
  margin-right: 0.5rem;
}
.related-events__list-container {
  overflow-x: scroll;
  overflow-y: hidden;
}

.related-events-modal__event-filters {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}
.related-events-modal__event-filters .related-events__search {
  padding-right: 0.5rem;
  width: 19rem;
}
.related-events-modal__event-filters .related-events__search .avt-react-components--input {
  height: 2.2rem;
}
.related-events-modal__event-filters .popout-select .avt-react-components--button.design-outlined.activity-tertiary.popout-select--trigger {
  background: #ffffff;
}
.related-events-modal__event-filters .select-period-component {
  background-color: #ffffff;
}
.related-events-modal__event-filters .event-timeline-filters {
  width: auto;
}
.related-events-modal__date-span {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.5rem;
}
.related-events-modal__date-span > .avt-react-components--icon {
  margin: 0 0.5rem;
}
.related-events-modal__date-time {
  display: flex;
}
.related-events-modal__date-time .date-picker .SingleDatePickerInput {
  padding: 0.3rem 0.5rem;
  color: rgb(10%, 10%, 10%);
}
.related-events-modal__date-time .date-picker .SingleDatePickerInput input {
  width: auto;
}
.related-events-modal__date-time .time-picker {
  padding: 0.3rem 0.5rem 0.3rem 0.3rem;
}
.related-events-modal__date-time > * + * {
  margin-left: 0.5rem;
}
.related-events-modal .valid-date .DateInput_input {
  color: rgb(10%, 10%, 10%);
}
.related-events-modal__date-time + .related-events-modal__date-time {
  margin-left: 0.5rem;
}
.related-events-modal__buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}
.related-events-modal__buttons button {
  margin-right: 0.5rem;
}
@media only screen and (max-width: 1350px) {
  .related-events-modal__event-filters {
    flex-direction: column;
    align-items: flex-end;
  }
  .related-events-modal__event-filters .related-events__search {
    margin-bottom: 0.5rem;
    padding-right: 0;
  }
  .related-events-modal__date-span {
    margin-bottom: 0.5rem;
  }
}

.light-theme .drop-zone {
  background: rgba(255, 255, 255, 0.9);
}

.dark-theme .drop-zone {
  background: rgba(10%, 10%, 10%, 0.9);
}
.dark-theme .event-timeline-domain-display {
  color: #666666;
}
.dark-theme .event-timeline-tooltip,
.dark-theme .tooltip-detail {
  background-color: rgba(15%, 15%, 15%, 0.85);
  color: rgb(90%, 90%, 90%);
}
.dark-theme .event-timeline-event-list-headers {
  background: rgb(15%, 15%, 15%);
  color: rgb(90%, 90%, 90%);
}
.dark-theme .event-timeline-event-list-headers :not(:last-child) {
  border-right: 0.2rem solid rgb(10%, 10%, 10%);
}
.dark-theme .event-timeline-list-item {
  background-color: rgb(10%, 10%, 10%);
  border-bottom: 1px solid rgba(65%, 65%, 65%, 0.3);
}
.dark-theme .event-timeline-list-item--critical {
  background-color: rgba(240, 48, 64, 0.15);
}
.dark-theme .event-timeline-list-item--warning {
  background-color: rgba(255, 216, 0, 0.1);
}
.dark-theme .event-timeline-list-item--limited-list {
  border: 0;
}
.dark-theme .event-timeline-list-item__label .event-label {
  color: black;
}
.dark-theme .event-timeline-list-item.event-timeline-list-item--limited-list {
  background-color: rgb(15%, 15%, 15%);
}
.dark-theme .event-timeline-list-item.event-timeline-list-item--limited-list.event-timeline-list-item--hovering {
  box-shadow: none;
  background-color: rgb(25%, 25%, 25%);
}
.dark-theme .event-timeline-filters .popout-select--trigger.round svg {
  color: #666666;
}
.dark-theme .event-timeline-filters .avt-react-components--input:hover:not(:focus) {
  border-color: #666666;
}
.dark-theme .event-timeline-filters .avt-react-components--input::placeholder {
  color: #666666;
}
.dark-theme .related-events__list .event-count {
  color: rgb(50%, 50%, 50%);
}
.dark-theme .related-events-modal__event-filters .popout-select .avt-react-components--button.design-outlined.activity-tertiary.popout-select--trigger {
  background: rgb(10%, 10%, 10%);
}
.dark-theme .related-events-modal__date-time .date-picker .SingleDatePickerInput {
  color: rgb(90%, 90%, 90%);
}
.dark-theme .related-events-modal .valid-date .DateInput_input {
  color: rgb(90%, 90%, 90%);
}
.dark-theme .related-events-modal__date-span > div > input::-webkit-calendar-picker-indicator {
  filter: invert(1);
}
.dark-theme .event-timeline-tooltip__details div span {
  color: rgb(90%, 90%, 90%);
}
.dark-theme .event-timeline-tooltip__severity {
  color: rgb(90%, 90%, 90%);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */